<template>
  <div class="config-detail-bu">
      <!-- <div class="title">{{assignBu.orgName}}</div>
      <el-input class="item" v-model="subAssignItem.assignQty" placeholder="请输入分配额度"></el-input> -->
      <div  v-if="buToCity===1">
        <el-form :model="subAssignItem" ref="editFormRef" :rules="editRules" hide-required-asterisk @submit.native.prevent>
          <el-form-item :label="assignName" prop="assignQty">
              <el-input type="number" :min="0" class="item" v-model="subAssignItem.assignQty" placeholder="请输入分配额度"  @blur="handleBlur"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="buToCity" v-else>
        <el-form :model="subAssignItem" ref="editFormRef" :rules="editRules" hide-required-asterisk @submit.native.prevent>
          <el-form-item :label="assignName" prop="assignQty">
              <el-input type="number" :min="0" class="item" v-model="subAssignItem.assignQty" placeholder="请输入分配额度" @blur="handleBlur"></el-input>
          </el-form-item>
        </el-form>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props:{
    // assignList: { type: Object, default: () => {} },
    assignItem: { type: Object, default: () => { } },
    //assignList:{ type: Array, default: () => [] },
    assignBuList:{ type: Array, default: () => [] },
    assignRegionList: { type: Array, default: () => [] },
    assignAreaList: { type: Array, default: () => [] },
    buToCity:{ type: Number, default: 0 },
    saveDetail:{ type: Object, default: () => { } },
    saveSubAssignList:{ type: Array, default: () => [] },
    srcAssignId:{type:String,default:''}
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  data(){
    return {
      employeeLevel:'',
      assignQty:'',
      subAssignItem:{
        assignQty:''
      },
      assignName:'',
      editRules:{
        // assignQty:[{ required: true, message: "请输入分配额度", trigger: "blur" }]
      },
      isRegion:true
    }
  },
  created(){
    this.employeeLevel = this.userInfo.employeeLevel
    this.assignName = this.assignItem.orgName.split('|')[0]
    if(this.employeeLevel>=90&&this.saveSubAssignList){
      if(this.saveSubAssignList.length>0){
        for(let save of this.saveSubAssignList){
          if(save.buCode === this.assignItem.orgCode){
            this.subAssignItem.assignQty = save.assignQty
          }
          // for(let item of this.assignBuList){
          //   console.log(save.buCode);
          //   console.log(item.orgCode);
          //   if(save.buCode === item.orgCode){
          //     this.subAssignItem.assignQty = save.assignQty
          //   }
          // }
        }
        this.subAssignItem.buCode = this.assignItem.orgCode
        this.subAssignItem.srcAssignId = '0'
      }
    }else if(this.saveSubAssignList){
      for(let save of this.saveSubAssignList){
        if(this.buToCity==1){
          if(save.regionCode == this.assignItem.parentOrgCode && save.assignLevel==='area'){
            if(save.areaCode === this.assignItem.orgCode){
              this.subAssignItem.assignQty = save.assignQty
              let data = {
                assignQty:save.assignQty,
                regionCode:save.regionCode,
                areaCode:save.areaCode,
                srcAssignId:save.srcAssignId
              }
              this.$emit("handleAssign",data)
            }
          }
        }else {
          if(save.regionCode === this.assignItem.orgCode && save.assignLevel==='region'){
            this.subAssignItem.assignQty = save.assignQty
            let data = {
              assignQty:save.assignQty,
              regionCode:save.regionCode,
              areaCode:save.areaCode,
              srcAssignId:save.srcAssignId
            }
            this.$emit("handleAssign",data)
          }else if(save.areaCode === this.assignItem.orgCode && save.assignLevel==='area'){
            this.subAssignItem.assignQty = save.assignQty
            let data = {
              assignQty:save.assignQty,
              regionCode:save.regionCode,
              areaCode:save.areaCode,
              srcAssignId:save.srcAssignId
            }
            this.$emit("handleAssign",data)
          }
        }
      }
    }
  },
  methods:{
    submit(){
      if(this.employeeLevel>=90){
        this.subAssignItem.buCode = this.assignItem.orgCode
        this.subAssignItem.srcAssignId = '0'
        this.subAssignItem.buChangeQty = this.subAssignItem.assignQty
      }else if(this.employeeLevel>=60&&this.employeeLevel<90){
        if(this.buToCity==1){
          this.subAssignItem.areaCode = this.assignItem.orgCode
          this.subAssignItem.regionCode = this.assignItem.parentOrgCode
          this.subAssignItem.srcAssignId = this.srcAssignId
        }else {
          this.subAssignItem.regionCode = this.assignItem.orgCode
          this.subAssignItem.srcAssignId = this.srcAssignId
          // this.assignItem.parentOrgCode?this.subAssignItem.areaCode = this.assignItem.parentOrgCode:''
        }
      }else if(this.employeeLevel>=45&&this.employeeLevel<60){
        this.subAssignItem.areaCode = this.assignItem.orgCode
        this.subAssignItem.srcAssignId = this.srcAssignId
      }
      this.$emit("handleSubmit",this.subAssignItem)
    },
    handleBlur(){
      if(this.employeeLevel>=60&&this.employeeLevel<90){
        if(this.buToCity==1){
          this.subAssignItem.areaCode = this.assignItem.orgCode
          this.subAssignItem.regionCode = this.assignItem.parentOrgCode
          this.subAssignItem.srcAssignId = this.srcAssignId
        }else {
          this.subAssignItem.regionCode = this.assignItem.orgCode
          this.subAssignItem.srcAssignId = this.srcAssignId
          // this.assignItem.parentOrgCode?this.subAssignItem.areaCode = this.assignItem.parentOrgCode:''
        }
      }else if(this.employeeLevel>=45&&this.employeeLevel<60){
        this.subAssignItem.areaCode = this.assignItem.orgCode
        this.subAssignItem.srcAssignId = this.srcAssignId
      }
      console.log(this.subAssignItem);
      this.$emit("handleAssign",this.subAssignItem)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item.is-error .el-input__inner,
.el-form-item.is-error .el-input__inner:focus, 
.el-form-item.is-error .el-textarea__inner, 
.el-form-item.is-error .el-textarea__inner:focus, 
.el-message-box__input input.invalid, 
.el-message-box__input input.invalid:focus {
  border-color: #c7c7c7 !important;
}
::v-deep .el-form-item {
  margin: 3px 0;
  .el-form-item__label {
    text-align: left;
    color: black;
    font-weight: 600;
  }

  .el-form-item__content {
    line-height: 35px !important;
  }
}

::v-deep .el-input__inner {
  width: 155px !important;
  padding-right: 25px;
}
.config-detail-bu{
  // display: flex;
}
.bu_item{
  margin: 0 15px 0 5px;
}
::v-deep  .el-form-item {
    margin: 3px 15px 0 25px !important;
    display: flex;
}
::v-deep  .buToCity .el-form-item {
    margin: 3px 15px 0 5px !important;
    display: flex;
    flex-direction: column;
}
.warning{
  display: inline-block;
  margin-left: 10px;
  color: red;
}
</style>